var React = require('react');

function UserInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M8.67 12h6.66a2 2 0 0 1 1.969 1.642l1.487 8.18A1 1 0 0 1 17.802 23H6.198a1 1 0 0 1-.984-1.179l1.487-8.179A2 2 0 0 1 8.67 12zM12 9a4 4 0 1 1 0-8 4 4 0 0 1 0 8z","stroke":"currentColor","strokeWidth":"2","fill":"none","strokeLinecap":"square","strokeLinejoin":"round"}));
}

UserInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = UserInline;

UserInline.default = UserInline;
